<template>
  <div
    style="
      width: 100%;
      height: 86vh;
      display: flex;
      margin-top: -6vh;
      position: relative;
    "
  >
    <!-- 左侧 -->
    <div class="left_panel" :class="getLeftFold ? '' : 'left_fold_close'">
      <!-- 左上 -->
      <div class="l_top">
        <div class="l_t_item">
          <img
            class="l_t_item_icon"
            src="../../assets/images/home/icon_t11.png"
            alt=""
          />
          <div class="l_t_item_title">
            {{ statisticsYear }}年<br />累计作业(小时)
          </div>
          <div class="l_t_item_num">
            {{
              (leftTopTotalData && leftTopTotalData.currentYearTotal
                ? leftTopTotalData.currentYearTotal.toFixed(0)
                : 0) | numberSeparator
            }}
          </div>
        </div>
        <div class="l_t_item">
          <img
            class="l_t_item_icon"
            src="../../assets/images/home/icon_t11.png"
            alt=""
          />
          <div class="l_t_item_title">
            {{ Number(statisticsYear) - 1 }}年<br />累计作业(小时)
          </div>
          <div class="l_t_item_num">
            {{
              (leftTopTotalData && leftTopTotalData.lastYearTotal
                ? leftTopTotalData.lastYearTotal.toFixed(0)
                : 0) | numberSeparator
            }}
          </div>
        </div>
        <div class="l_t_item">
          <img
            class="l_t_item_icon"
            src="../../assets/images/home/icon_t12.png"
            alt=""
          />
          <div class="l_t_item_title">有效作业周期(天)</div>
          <div class="l_t_item_num">
            {{
              (leftTopTotalData && leftTopTotalData.jobCycle
                ? leftTopTotalData.jobCycle
                : 0) | numberSeparator
            }}
          </div>
        </div>
      </div>
      <!-- 左中 -->
      <div class="l_center">
        <Block :title="`${statisticsYear}年各作业类型作业量`">
          <div class="l_c_header">
            <div class="item">作业类型</div>
            <div class="item">作业量</div>
          </div>
          <vue-seamless-scroll
            :data="leftCenterList"
            class="seamless-warp"
            v-if="leftCenterList && leftCenterList.length > 0"
            :class-option="{ ...classOption, limitMoveNum: 4 }"
          >
            <div class="l_c_item" v-for="(v, i) in leftCenterList" :key="i">
              <div class="item">{{ v.name || "--" }}</div>
              <div class="item">
                {{ (v.value || 0) | numberSeparator }} ({{ v.unit || "--" }})
              </div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <div class="l_bottom_center">
        <Block :title="`${getLastAddreassName}实时作业数据`">
          <vue-seamless-scroll
            :data="realTimeJobList"
            class="seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 3 }"
            v-if="realTimeJobList && realTimeJobList.length > 0"
          >
            <div class="l_b_item" v-for="(v, i) in realTimeJobList" :key="i">
              <div class="l_b_item_left">
                {{
                  v.jobStartTime ? parseTime(v.jobStartTime, "{m}-{d}") : "--"
                }}
                <br />
                {{
                  v.jobStartTime
                    ? parseTime(v.jobStartTime, "{h}:{i}:{s}")
                    : "--"
                }}
              </div>
              <div class="l_b_item_right">
                <div class="l_b_item_right_top">
                  IMEI号：{{ v.drcId || "--" }}
                </div>
                <div class="l_b_item_right_center">
                  {{ v.jobTypeName || "--" }}：{{ v.jobArea || "--" }}
                  {{ v.unit || "--" }}
                </div>
                <div class="l_b_item_right_bottom">
                  作业地点：{{ v.currAddress || v.address || "--" }}
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <!-- 左下 -->
      <div class="l_bottom">
        <Block :title="`${statisticsYear}年月度各作业类型作业量`">
          <el-select
            v-model.trim="echartsSearchParams.leftBottomMonth"
            placeholder=""
            class="work_select month_select"
            v-if="workTypes && workTypes.length > 1"
          >
            <el-option
              v-for="item in monthOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <left-bottom-chart
            height="100%"
            :chartData="leftBottomData"
            :unit="echartsSearchParams.leftBottomUnit"
            v-if="workTypes && workTypes.length > 1"
          ></left-bottom-chart>
          <div v-else class="empty_panel"></div>
          <el-select
            v-model.trim="echartsSearchParams.leftBottomJobType"
            placeholder=""
            class="work_select"
            v-if="workTypes && workTypes.length > 1"
          >
            <el-option
              v-for="item in workTypes.filter((v) => {
                return v.jobTypeCode;
              })"
              :key="item.jobTypeCode"
              :label="item.jobTypeName"
              :value="item.jobTypeCode"
            ></el-option>
          </el-select>
        </Block>
      </div>
    </div>
    <!-- 中间终端类型选择 -->
    <div class="drc_select" :class="getRightFold ? '' : 'right_fold_close'">
      <el-select
        v-model.trim="terminalType"
        placeholder=""
        class="work_select"
        popper-class="drc_select_popper"
      >
        <el-option
          v-for="item in terminalTypeSelectOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        ></el-option>
      </el-select>
    </div>
    <!-- 类型选择 -->
    <template v-if="terminalType == 0 || terminalType == 2">
      <div
        @click="filterPanelVisible = !filterPanelVisible"
        :class="{ active: filterPanelVisible, [dvStyle]: dvStyle }"
        class="filter-panel-switch"
        :title="`${filterPanelVisible ? '隐藏' : '显示'}左侧的几个单选项`"
      ></div>
      <template v-if="filterPanelVisible">
        <div
          class="filter-panel-bg"
          :class="{ canVisibleSeasonProgress, [dvStyle]: dvStyle }"
        ></div>
        <div class="filter-panel-top" :class="{ [dvStyle]: dvStyle }">
          <el-switch
            v-model="isShowWorkLayer"
            active-color="#38D180"
            :active-value="true"
            :inactive-value="null"
            @change="workLayerChange()"
            inactive-color="#cccccc"
          ></el-switch>
          <span class="text">作业地块分布</span>
        </div>

        <div class="filter-panel-bottom" :class="{ [dvStyle]: dvStyle }">
          <el-switch
            v-model="isMassPoint"
            active-color="#915501"
            :active-value="true"
            :inactive-value="null"
            @change="wmtsPointLayerChange()"
            inactive-color="#cccccc"
          ></el-switch>
          <span class="text">轨迹点分布</span>
        </div>

        <div
          class="filter-panel-bottom level-2"
          :class="{ [dvStyle]: dvStyle }"
          v-if="canVisibleSeasonProgress"
        >
          <el-switch
            v-model="isProgressSwitchSelected"
            :disabled="seasonProgressLoading"
            :title="`${seasonProgressLoading ? '加载中' : ''}`"
            active-color="#F8B62D"
            :active-value="true"
            :inactive-value="null"
            @change="wmtsPointLayerChange()"
            inactive-color="#cccccc"
          ></el-switch>
          <span class="text">{{ seasonName }}收割进度</span>
        </div>
      </template>
    </template>

    <div class="map_container">
      <cityMap
        id="home_map_"
        ref="mapModel"
        :machineryType="currentMachineryType"
        :progressSwitchSelected.sync="isProgressSwitchSelected"
        @seasonProgressLoading="seasonProgressLoading = $event"
        @townshipPoint="townshipPoint"
      ></cityMap>
    </div>
    <!-- 右侧 -->
    <div class="right_panel" :class="getRightFold ? '' : 'right_fold_close'">
      <!-- 右上 -->
      <div class="r_top">
        <div class="r_t_item">
          <img
            class="r_t_item_icon"
            src="../../assets/images/home/icon_t13.png"
            alt=""
          />
          <div class="r_t_item_title">
            {{ statisticsYear }}年<br />作业量({{
              rightTopTotalData.unit || "亩"
            }})
          </div>
          <div class="r_t_item_num">
            {{
              (rightTopTotalData && rightTopTotalData.currentJobTotal
                ? rightTopTotalData.currentJobTotal.toFixed(0)
                : 0) | numberSeparator
            }}
          </div>
        </div>
        <div class="r_t_item">
          <img
            class="r_t_item_icon"
            src="../../assets/images/home/icon_t13.png"
            alt=""
          />
          <div class="r_t_item_title">
            {{ Number(statisticsYear) - 1 }}年<br />作业量({{
              rightTopTotalData.unit || "亩"
            }})
          </div>
          <div class="r_t_item_num">
            {{
              (rightTopTotalData && rightTopTotalData.lastJobTotal
                ? rightTopTotalData.lastJobTotal.toFixed(0)
                : 0) | numberSeparator
            }}
          </div>
        </div>
        <div class="r_t_item">
          <img
            class="r_t_item_icon"
            src="../../assets/images/home/icon_t14.png"
            alt=""
          />
          <div class="r_t_item_title">同比完成率</div>
          <div class="r_t_item_num">
            {{
              (rightTopTotalData && rightTopTotalData.lastJobTotal
                ? rightTopTotalData.lastJobTotal.toFixed(0)
                : 0) == 0
                ? "--"
                : rightTopTotalData && rightTopTotalData.ratio
                ? rightTopTotalData.ratio + "%"
                : 0 + "%" || 0 + "%"
            }}
          </div>
        </div>
      </div>
      <!-- 右中 -->
      <div class="r_center">
        <Block :title="`${statisticsYear}年各作业类型作业量同比/环比`">
          <div class="chart_info" v-if="workTypes && workTypes.length > 1">
            <rightTopChart
              width="56%"
              :jobTypeName="echartsSearchParams.rightTopName"
              :chartData="rightTopDataFormat"
              :unit="echartsSearchParams.rightTopUnit"
            ></rightTopChart>
            <div class="info_panel">
              <div class="switch_panel">
                <div
                  class="btn"
                  @click="rightTopSwitch = 1"
                  :class="rightTopSwitch == 1 ? 'active' : ''"
                >
                  同比
                </div>
                <div
                  class="btn"
                  @click="rightTopSwitch = 2"
                  :class="rightTopSwitch == 2 ? 'active' : ''"
                >
                  环比
                </div>
              </div>
              <div class="i_item">
                <div class="i_top">{{ rightTopDataFormat.barName2 }}</div>
                <div class="i_center">
                  {{ echartsSearchParams.rightTopName || "--" }}作业量
                </div>
                <div class="i_bottom">
                  {{
                    (rightTopData.current ? rightTopData.current : 0)
                      | numberSeparator
                  }}
                </div>
              </div>
              <div class="i_item">
                <div class="i_top">{{ rightTopDataFormat.barName1 }}</div>
                <div class="i_center">
                  {{ echartsSearchParams.rightTopName || "--" }}作业量
                </div>
                <div class="i_bottom">
                  {{
                    (rightTopSwitch == 1
                      ? rightTopData.beforeYear
                        ? rightTopData.beforeYear
                        : 0
                      : rightTopData.beforeMonth
                      ? rightTopData.beforeMonth
                      : 0) | numberSeparator
                  }}
                </div>
              </div>
              <div class="i_item">
                <div class="i_top">
                  {{ echartsSearchParams.rightTopName || "--" }}作业量
                </div>
                <div class="i_center">
                  {{ rightTopSwitch == 1 ? "同比" : "环比" }}
                  <span
                    :class="
                      Number(
                        rightTopSwitch == 1
                          ? rightTopData.beforeYearRatio
                          : rightTopData.beforeMonthRatio
                      ) < 0
                        ? 'other'
                        : ''
                    "
                    >{{
                      Number(
                        rightTopSwitch == 1
                          ? rightTopData.beforeYearRatio
                          : rightTopData.beforeMonthRatio
                      ) < 0
                        ? "减少"
                        : "增长"
                    }}</span
                  >
                </div>
                <div class="i_bottom">
                  <span
                    class="icon"
                    :class="
                      Number(
                        rightTopSwitch == 1
                          ? rightTopData.beforeYearRatio
                          : rightTopData.beforeMonthRatio
                      ) < 0
                        ? 'rotate'
                        : ''
                    "
                  ></span>
                  {{
                    (rightTopSwitch == 1
                      ? rightTopData.beforeYear
                        ? rightTopData.beforeYear
                        : 0
                      : rightTopData.beforeMonth
                      ? rightTopData.beforeMonth
                      : 0) == 0
                      ? "--"
                      : Math.abs(
                          rightTopSwitch == 1
                            ? rightTopData.beforeYearRatio
                            : rightTopData.beforeMonthRatio
                        ) + "%" || 0 + "%"
                  }}
                </div>
              </div>
              <el-select
                v-model.trim="echartsSearchParams.rightTopMonth"
                placeholder=""
                class="work_select month_select"
              >
                <el-option
                  v-for="item in monthOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div v-else class="empty_panel"></div>
          <el-select
            v-model.trim="echartsSearchParams.rightTopJobType"
            placeholder=""
            v-if="workTypes && workTypes.length > 1"
            class="work_select"
          >
            <el-option
              v-for="item in workTypes.filter((v) => {
                return v.jobTypeCode;
              })"
              :key="item.jobTypeCode"
              :label="item.jobTypeName"
              :value="item.jobTypeCode"
            ></el-option>
          </el-select>
        </Block>
      </div>
      <!-- 右下 -->
      <div class="r_bottom">
        <Block :title="`${statisticsYear}年农机平均作业量`">
          <rightBottomChart
            :chartData="rightBottomData"
            v-if="workTypes && workTypes.length > 1"
            :unit="echartsSearchParams.rightBottomUnit"
          ></rightBottomChart>
          <div v-else class="empty_panel"></div>
          <el-select
            v-model.trim="echartsSearchParams.rightBottomJobType"
            placeholder=""
            class="work_select"
            v-if="workTypes && workTypes.length > 1"
          >
            <el-option
              v-for="item in workTypes.filter((v) => {
                return v.jobTypeCode;
              })"
              :key="item.jobTypeCode"
              :label="item.jobTypeName"
              :value="item.jobTypeCode"
            ></el-option>
          </el-select>
        </Block>
      </div>
    </div>
    <Modal
      :show="townshipDialog"
      :title="townshipInfo.pointName"
      width="11.9vw"
      :showColse="false"
      class="township-dialog"
      :setStyle="getTownshipStyle"
    >
      <div slot="content" class="modal-content" style="padding: 10px 0px">
        <div v-html="townshipInfo.description"></div>
      </div>
    </Modal>
    <!-- 筛选条件 -->
    <div class="select_panel">
      <div class="select_left">
        <div class="label">统计年份</div>
        <el-select
          size="mini"
          v-model.trim="statisticsYear"
          placeholder=""
          class="work_select year_panel"
        >
          <el-option
            v-for="item in yearOptions"
            :key="item.text"
            :label="item.text"
            :value="item.text"
          ></el-option>
        </el-select>
      </div>
      <div class="select_right">
        <div class="label">查看维度</div>
        <el-select
          size="mini"
          v-model.trim="viewArea"
          placeholder=""
          class="work_select viewarea_panel"
        >
          <el-option
            v-for="item in getSelectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <JobTypeSelect
      v-model="currentjobType"
      :options="workTypes"
      @change="slectType"
    />
  </div>
</template>
<script>
import cityMap from "./components/mapModel";
import LeftBottomChart from "./components/left_bottom_chart";
import RightBottomChart from "./components/right_bottom_chart";
import RightTopChart from "./components/right_top_chart";
import * as workInfoApi from "@/api/workInfo";
import * as homeApi from "@/api/home";
import * as commonApi from "@/api/common";
import iconMap from "@/utils/iconType";
import JobTypeSelect from "@components/jobTypeSelect";
import Block from "@components/block";
const PAGE_SIZAE = 6;
import { parseTime } from "@/utils/index";
import Modal from "@components/modal.vue";
import { mapGetters } from "vuex";
const DV_STYLE = {
  410928000: "green", // 濮阳市濮阳县
  411121000: "blue", // 漯河市舞阳县
  410526000: "blue", // 安阳市滑县
  410225000: "green", // 开封市兰考县
};

export default {
  components: {
    Modal,
    Block,
    cityMap,
    LeftBottomChart,
    RightBottomChart,
    RightTopChart,
    JobTypeSelect,
  },
  mounted() {
    for (let index = 0; index < new Date().getFullYear() - 2021; index++) {
      const year = 2022 + index;
      this.yearOptions.push({
        text: year,
      });
    }
    this.getLargeScreenWorkType();
  },
  watch: {
    /** 路由监听 处理左右bg图变化 */
    $route: {
      handler(route) {
        if (
          route.path == "/" ||
          route.path == "/home" ||
          route.path == "/home/"
        ) {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        } else this.setTimer();
      },
      deep: true,
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        const city = "city_" + val.areaCode;
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.removeWmtsPointLayer();
            this.$refs.mapModel.removeWorkLayer();
            if (this.isShowWorkLayer) {
              this.$refs.mapModel.workLayer(
                this.$store.state.activeRegionObj.areaCode,
                this.getCurrentMapJobType(),
                this.commonParams
              );
            }
            this.$refs.mapModel.addProvince(city);
          }
        });
        this.initPageData();
      },
    },
    "echartsSearchParams.leftBottomJobType": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          if (oldVal != newVal) this.getLeftBottomData();
          this.echartsSearchParams.leftBottomUnit =
            this.workTypes.find((v) => {
              return v.jobTypeCode == newVal;
            }).unit || "亩";
        }
      },
    },
    "echartsSearchParams.rightTopJobType": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          if (oldVal != newVal) this.getRightTopData();
          this.echartsSearchParams.rightTopUnit =
            this.workTypes.find((v) => {
              return v.jobTypeCode == newVal;
            }).unit || "亩";
          this.echartsSearchParams.rightTopName =
            this.workTypes.find((v) => {
              return v.jobTypeCode == newVal;
            }).jobTypeName || "--";
        }
      },
    },
    "echartsSearchParams.rightBottomJobType": {
      deep: true,
      handler(val) {
        if (val) {
          this.getRightBottomData();
          this.echartsSearchParams.rightBottomUnit =
            this.workTypes.find((v) => {
              return v.jobTypeCode == val;
            }).unit || "亩";
        }
      },
    },
    /** 左下月份变更 */
    "echartsSearchParams.leftBottomMonth": {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal != newVal) this.getLeftBottomData();
      },
    },
    /** 左下月份变更 */
    "echartsSearchParams.rightTopMonth": {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal != newVal) this.getRightTopData();
      },
    },
    /** 数据范围 */
    viewArea: {
      deep: true,
      handler(val) {
        //this.getJobType();
        this.initPageData();
      },
    },
    /** 统计年份 */
    statisticsYear: {
      deep: true,
      handler(val) {
        //this.getJobType();
        this.initPageData();
      },
    },
    // 终端类型
    terminalType: {
      handler(val) {
        if (val == 0 || val == 2) {
          this.isMassPoint = true;
          this.isShowWorkLayer = true;
        } else {
          this.isShowWorkLayer = true;
          this.isMassPoint = false;
        }
        this.currentjobType = null;
        //this.getJobType();
        this.initPageData();
      },
    },
    canVisibleSeasonProgress: {
      handler(v) {
        let self = this;
        if (v) {
          self.isProgressSwitchSelected = true;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      parseTime,
      iconMap,
      // 乡镇统计显示
      townshipDialog: false,
      // 乡镇统计信息
      townshipInfo: {},
      // 作业类型
      workTypes: [],
      //作业类型code
      workTypeCodes: [],
      // 选择作业类型
      currentjobType: null,
      // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      currentMachineryType: 0,
      // 左侧-中间-列表数据
      leftCenterList: [],
      // 左下-图表数据
      leftBottomData: {
        barList: [],
        regionList: [],
      },
      // 图表作业类型筛选
      echartsSearchParams: {
        leftBottomJobType: null,
        leftBottomUnit: "亩",
        rightTopJobType: null,
        rightTopUnit: "亩",
        rightBottomJobType: null,
        rightBottomUnit: "亩",
        leftBottomMonth: new Date().getMonth() + 1,
        rightTopMonth: new Date().getMonth() + 1,
      },
      // 右上图标数据（请求数据
      rightTopData: {
        current: 0, // 当前月份作业量
        beforeYear: 0, // 上年同期作业量
        beforeMonth: 0, // 上月同期作业量
        beforeYearRatio: 0.0, // 同比比例（与去年同期作业量比例）
        beforeMonthRatio: 0.0, // 环比比例（与上月作业量比例）
      },
      // 右上切换 1同比2环比
      rightTopSwitch: 1,
      // 右下图标数据
      rightBottomData: {},
      // 是否为区域内筛选
      isJobArea: 1,
      // 数据范围
      viewArea: 1,
      // 统计年份
      statisticsYear: new Date().getFullYear(),
      // 年份下拉
      yearOptions: [],
      // 月份下拉
      monthOptions: [
        { value: 1, label: "1月" },
        { value: 2, label: "2月" },
        { value: 3, label: "3月" },
        { value: 4, label: "4月" },
        { value: 5, label: "5月" },
        { value: 6, label: "6月" },
        { value: 7, label: "7月" },
        { value: 8, label: "8月" },
        { value: 9, label: "9月" },
        { value: 10, label: "10月" },
        { value: 11, label: "11月" },
        { value: 12, label: "12月" },
      ],
      // 右上作业量统计
      rightTopTotalData: {},
      // 左上作业时长统计
      leftTopTotalData: {},
      // 实时上线数据
      realTimeJobList: [],
      // 终端类型选择
      terminalType: "0",
      // 终端类型下拉
      terminalTypeSelectOptions: [],
      // 是否展示作业地块
      isShowWorkLayer: true,
      // 是否展示海量点分布
      isMassPoint: true,
      // 三夏收割进度
      isProgressSwitchSelectedValue: false,
      filterPanelVisible: true,
      seasonProgressLoading: false,
    };
  },
  computed: {
    isProgressSwitchSelected: {
      set(v) {
        let self = this;
        self.isProgressSwitchSelectedValue = self.canVisibleSeasonProgress
          ? v
          : false;
      },
      get() {
        let self = this;
        return self.canVisibleSeasonProgress
          ? self.isProgressSwitchSelectedValue
          : false;
      },
    },
    // 数据维度[]
    getSelectList() {
      return [
        { value: 1, label: `智能农机在${this.getLastAddreassName}作业数据` }, // 范围：1 是否区域：1
        {
          value: 2,
          label: `${this.getLastAddreassName}农机在${this.getLastAddreassName}作业数据`,
        }, // 范围：3 是否区域：1
        {
          value: 3,
          label: `${this.getLastAddreassName}农机在${this.getLastPreAddreassName}作业数据`,
        }, // 范围：2 是否区域：0
        { value: 4, label: `${this.getLastAddreassName}农机在河南省作业数据` }, // 范围：1 是否区域：0
        { value: 5, label: `${this.getLastAddreassName}农机在全国作业数据` }, // 范围：0 是否区域：0
      ];
    },
    ...mapGetters([
      "getLeftFold",
      "getRightFold",
      "getLastAddreassName",
      "getLastPreAddreassName",
      "getactiveRegionObj",
      "season",
    ]),
    seasonName() {
      let self = this;
      const v = self.season;
      const dict = { SX: "三夏", SQ: "三秋" };
      const name = dict[v] || "季度";
      return name;
    },
    // 有「AI调度」权限时可查看作业进度的完成度
    canVisibleSeasonProgress() {
      let self = this;
      const p = "screen:aiDispatch";
      const permissions = self.$store.getters.permissions || [];
      let can = !!permissions.find((v) => v == p);
      console.log(
        "%c是否有权查看地图上的「作业进度.收割完成进度」",
        "color:#CC0",
        can
      );
      return can;
    },
    dvStyle() {
      let self = this;
      const area = self.$store.state.activeRegionObj || {};
      const areaCode = area.areaCode;
      let style = DV_STYLE[areaCode] || "green";
      return style;
    },
    getTownshipStyle() {
      return {
        left: (this.townshipInfo.x - 240 || 0) + "px",
        top: (this.townshipInfo.y - 40 || 0) + "px",
      };
    },
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    /** 右上数据格式化处理 */
    rightTopDataFormat() {
      /** 当前选择年月 */
      let nowSelectTime = new Date(
        `${this.statisticsYear}.${this.echartsSearchParams.rightTopMonth}`
      );
      /** 上一年 */
      let year_Mill = new Date(nowSelectTime).setFullYear(
        new Date(nowSelectTime).getFullYear() - 1
      );
      /** 上一月 */
      let month_Mill = new Date(nowSelectTime).setMonth(
        new Date(`${nowSelectTime}`).getMonth() - 1
      );
      if (this.rightTopSwitch == 1) {
        return {
          regionList: [
            parseTime(year_Mill, "{y}.{m}"),
            parseTime(nowSelectTime, "{y}.{m}"),
          ],
          valueList1: [
            this.rightTopData && "beforeYear" in this.rightTopData
              ? this.rightTopData.beforeYear
              : 0,
            null,
          ],
          valueList2: [
            null,
            this.rightTopData && "current" in this.rightTopData
              ? this.rightTopData.current
              : 0,
          ],
          barName1: parseTime(year_Mill, "{y}年{m}月"),
          barName2: parseTime(nowSelectTime, "{y}年{m}月"),
        };
      } else {
        return {
          regionList: [
            parseTime(month_Mill, "{y}.{m}"),
            parseTime(nowSelectTime, "{y}.{m}"),
          ],
          valueList1: [this.rightTopData.beforeMonth || 0, null],
          valueList2: [
            null,
            this.rightTopData && "current" in this.rightTopData
              ? this.rightTopData.current
              : 0,
          ],
          barName1: parseTime(month_Mill, "{y}年{m}月"),
          barName2: parseTime(nowSelectTime, "{y}年{m}月"),
        };
      }
      return;
    },
    commonParams() {
      let params = {
        isJobArea: null, // 是否为区域内作业，0-全国，1-全省，2-全市，3-全县
        viewArea: null, // 查看数据范围;0-全国，1-全省，2-全市，3-全县
        viewYear: this.statisticsYear, // 统计年份
        type: this.terminalType, // 作业类型
      };
      // viewArea-isJobArea
      // 智能农机在本县 0-3
      // 本县农机在本县 3-3
      // 本县农机在本市 3-2
      // 本县农机在本省 3-1
      // 本县农机在全国 3-0
      switch (this.viewArea) {
        case 1:
          params.viewArea = 0;
          params.isJobArea = 3;
          break;
        case 2:
          params.viewArea = 3;
          params.isJobArea = 3;
          break;
        case 3:
          params.viewArea = 3;
          params.isJobArea = 2;
          break;
        case 4:
          params.viewArea = 3;
          params.isJobArea = 1;
          break;
        case 5:
          params.viewArea = 3;
          params.isJobArea = 0;
          break;
        default:
          break;
      }
      return params;
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  },
  created() {
    this.getTrminalTypeSelectOptions();
  },
  methods: {
    // 大屏作业进度终端类型下拉列表
    getTrminalTypeSelectOptions() {
      homeApi.getDictData("terminal_type_select_options").then((res) => {
        this.terminalTypeSelectOptions = res || [];
      });
    },
    // 获取综合统计默认展示
    getLargeScreenWorkType() {
      homeApi.getDictData("large_screen_work_type").then((res) => {
        let list = res || [];
        let findData =
          list && list.length > 0
            ? list.find((v) => {
                return v.dictLabel == this.getactiveRegionObj.areaCode;
              })
            : null;
        this.terminalType =
          findData && findData.dictValue ? findData.dictValue : "0";
      });
    },
    // 是否展示作业地块分布
    workLayerChange() {
      if (this.isShowWorkLayer) {
        this.$nextTick(() => {
          this.$refs.mapModel.workLayer(
            this.$store.state.activeRegionObj.areaCode,
            this.getCurrentMapJobType(),
            this.commonParams
          );
        });
      } else {
        this.$refs.mapModel.removeWorkLayer();
      }
    },
    // 是否展示海量点分布
    getMapJobType(selectedItem) {
      if (!selectedItem) return this.currentjobType;
      const childLists = selectedItem.childLists;
      if (Array.isArray(childLists) && childLists.length > 0) {
        const jobTypes = childLists
          .map((item) => item && item.name)
          .filter((name) => name !== undefined && name !== null && name !== "");
        return jobTypes.length > 0 ? jobTypes : selectedItem.jobTypeCode;
      }
      return selectedItem.jobTypeCode;
    },
    getCurrentMapJobType() {
      const selectedItem = this.workTypes.find((v) => {
        return v.jobTypeCode == this.currentjobType;
      });
      return selectedItem ? this.getMapJobType(selectedItem) : this.currentjobType;
    },
    wmtsPointLayerChange() {
      if (this.isMassPoint) {
        this.$refs.mapModel.wmtsPointLayer(
          this.currentjobType,
          this.workTypeCodes,
          this.statisticsYear
        );
      } else {
        this.$refs.mapModel.removeWmtsPointLayer();
      }
    },
    /** 计时器 */
    setTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getJobType();
        this.getLeftTopData();
        this.getJobTotalTime();
        this.getRealTimeJobFx();
        this.getCurrYearJobAreaSum();
        this.getTownPointList();
        this.getLeftBottomData();
        this.getRightBottomData();
        this.getRightTopData();
      }, 1000 * 60);
    },
    /** 查询乡镇信息及点位列表 */
    getTownPointList() {
      commonApi
        .getTownPointList({ belong: 2, year: this.statisticsYear })
        .then((res) => {
          this.$refs.mapModel.setTownship(res);
        });
    },
    /** 乡镇统计交互 */
    townshipPoint(isShow, info) {
      this.townshipDialog = isShow;
      this.townshipInfo = info || {};
    },
    /** 查询当年、去年累计作业量及同比完成率 */
    getCurrYearJobAreaSum() {
      workInfoApi
        .getCurrYearJobAreaSum({
          jobType: this.currentjobType,
          ...this.commonParams,
        })
        .then((res) => {
          this.rightTopTotalData = res;
        });
    },
    /** 作业类型选择 */
    slectType(e) {
      this.$set(this, "currentjobType", e.jobTypeCode);
      this.getJobTotalTime();
      this.getLeftTopData();
      this.getRealTimeJobFx();
      this.getCurrYearJobAreaSum();
      this.$nextTick(() => {
        if (this.isShowWorkLayer) {
          this.$refs.mapModel.workLayer(
            this.$store.state.activeRegionObj.areaCode,
            this.getMapJobType(e),
            this.commonParams
          );
        } else {
          this.$refs.mapModel.removeWorkLayer();
        }
        if (
          this.isMassPoint &&
          (this.currentjobType == 199 ||
            this.currentjobType == 188 ||
            this.currentjobType)
        ) {
          this.$refs.mapModel.wmtsPointLayer(
            this.currentjobType,
            this.workTypeCodes,
            this.statisticsYear
          );
        } else {
          this.$refs.mapModel.removeWmtsPointLayer();
        }
      });
      if (e.jobTypeCode) {
        this.echartsSearchParams = {
          ...this.echartsSearchParams,
          leftBottomJobType: e.jobTypeCode,
          rightTopJobType: e.jobTypeCode,
          rightBottomJobType: e.jobTypeCode,
        };
        this.setTimer();
      }
    },
    /** 初始化页面 */
    initPageData() {
      this.getJobType();
      this.getLeftTopData();
      this.getJobTotalTime();
      this.getCurrYearJobAreaSum();
      this.getTownPointList();
      this.getRightTopData();
      this.getLeftBottomData();
      this.getRealTimeJobFx();
      // 是否展示地块
      if (this.isShowWorkLayer) {
        this.$nextTick(() => {
          this.$refs.mapModel.workLayer(
            this.$store.state.activeRegionObj.areaCode,
            this.getCurrentMapJobType(),
            this.commonParams
          );
        });
      } else {
        this.$refs.mapModel.removeWorkLayer();
      }
    },
    /** 获取作业类型 */
    getJobType() {
      if (this.$refs.mapModel) this.$refs.mapModel.removeWmtsPointLayer();
      workInfoApi
        .getJobType({ type: this.terminalType, ...this.commonParams })
        .then((res) => {
          if (res && res.length > 0) {
            this.echartsSearchParams = {
              ...this.echartsSearchParams,
              leftBottomJobType: res[0].name,
              rightTopJobType: res[0].name,
              rightBottomJobType: res[0].name,
            };
          }
          res = res.map((v) => {
            v.icon = this.iconMap[String(v.name)]
              ? this.iconMap[String(v.name)].jobIcon
              : this.iconMap["default"].jobIcon;
            v.iconActive = this.iconMap[String(v.name)]
              ? this.iconMap[String(v.name)].jobIconActive
              : this.iconMap["default"].jobIconActive;
            return {
              unit: v.unit,
              icon: v.icon,
              iconActive: v.iconActive,
              jobTypeCode: v.name,
              jobTypeName: v.value,
              childLists: v.childLists,
            };
          });
          /*
          if (
            res.length > 0 &&
            !res.some((v) => {
              return v.jobTypeCode == "188";
            })
          )
            res.unshift({
              unit: undefined,
              jobTypeCode: "188",
              jobTypeName: "收获类作业",
              icon: this.iconMap["188"].jobIcon,
              iconActive: this.iconMap["188"].jobIconActive,
            });
          if (
            res.length > 0 &&
            !res.some((v) => {
              return v.jobTypeCode == "199";
            })
          )
            res.unshift({
              unit: undefined,
              jobTypeCode: "199",
              jobTypeName: "耕整类作业",
              icon: this.iconMap["199"].jobIcon,
              iconActive: this.iconMap["199"].jobIconActive,
            });
          */
          res.unshift({
            unit: undefined,
            jobTypeCode: undefined,
            jobTypeName: "全部",
            icon: this.iconMap["default"].jobIcon,
            iconActive: this.iconMap["default"].jobIconActive,
          });
          this.workTypes = res;
          console.log("this.workTypes::", this.workTypes);
          this.workTypeCodes = [];
          this.workTypes.forEach((item) => {
            if (item.jobTypeCode) {
              this.workTypeCodes.push(item.jobTypeCode);
            }
          });
          // 是否展示海量点
          if (this.isMassPoint) {
            this.$refs.mapModel.wmtsPointLayer(
              this.currentjobType,
              this.workTypeCodes,
              this.statisticsYear
            );
          }
        });
    },
    /** 本年各作业类型作业量 */
    getLeftTopData() {
      workInfoApi
        .getAreaSumByType({
          jobType: this.currentjobType,
          ...this.commonParams,
        })
        .then((res) => {
          this.leftCenterList = res.filter((v) => {
            v.value = Number(v.value).toFixed(0);
            return v.value != 0;
          });
        });
    },
    /** 获取右上角数据 */
    getRightTopData() {
      workInfoApi
        .getRatioByType({
          jobType: this.echartsSearchParams.rightTopJobType,
          viewMonth: this.echartsSearchParams.rightTopMonth,
          ...this.commonParams,
        })
        .then((res) => {
          this.rightTopData = Object.assign(res, {
            current: Number(res.current).toFixed(0),
            beforeYear: Number(res.beforeYear).toFixed(0),
            beforeMonth: Number(res.beforeMonth).toFixed(0),
          }) || {
            current: 0, // 当前月份作业量
            beforeYear: 0, // 上年同期作业量
            beforeMonth: 0, // 上月同期作业量
            beforeYearRatio: 0.0, // 同比比例（与去年同期作业量比例）
            beforeMonthRatio: 0.0, // 环比比例（与上月作业量比例）
          };
        });
    },
    /** 各作业量统计 */
    getLeftBottomData() {
      workInfoApi
        .getWorkAmountByType({
          jobType: this.echartsSearchParams.leftBottomJobType,
          viewMonth: this.echartsSearchParams.leftBottomMonth,
          ...this.commonParams,
        })
        .then((res) => {
          this.leftBottomData = {
            barList: res.map((v) => {
              return Number(v.value).toFixed(0);
            }),
            regionList: res.map((v) => {
              return v.day;
            }),
          };
        });
    },
    /** 农机平均作业量 */
    getRightBottomData() {
      workInfoApi
        .getSingleAvgWorkAmountByType({
          jobType: this.echartsSearchParams.rightBottomJobType,
          ...this.commonParams,
        })
        .then((res) => {
          this.rightBottomData = res || [];
        });
    },
    /** 获取累计作业时长（小时） */
    getJobTotalTime() {
      workInfoApi
        .getJobTotalTime({ jobType: this.currentjobType, ...this.commonParams })
        .then((res) => {
          this.leftTopTotalData = res;
        });
    },
    /** 获取实时作业数据 */
    getRealTimeJobFx() {
      workInfoApi
        .getRealTimeJobFx({
          jobType: this.currentjobType,
          ...this.commonParams,
        })
        .then((res) => {
          this.realTimeJobList = res;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: vh(1080);
  float: right;
}
// 左侧样式
::v-deep.left_panel,
::v-deep.right_panel {
  width: vw(390);
  z-index: 100;
  padding-left: vw(24);
  display: flex;
  flex-direction: column;
  position: relative;
  // 左上
  .l_top,
  .r_top {
    height: vh(166);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: vh(0);
    .l_t_item,
    .r_t_item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      left: vw(8);
      padding-top: vh(16);
      &:last-child {
        left: vw(14);
      }
      &_icon {
        width: vw(56);
        height: vh(42);
      }
      &_title {
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        white-space: nowrap;
        height: vh(47);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &_num {
        font-size: fontSize(19);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0dffa9;
        padding-top: vh(0.5);
      }
    }
  }
  // 左中
  .l_center {
    display: flex;
    flex-direction: column;
    padding-bottom: vh(20);
    height: vh(237);
    .b_container,
    .seamless-warp {
      overflow: hidden;
    }
    .l_c_header,
    .l_c_item {
      height: vh(50);
      line-height: vh(50);
      display: flex;
      margin-left: vw(6);
      margin-right: vw(56);
      padding-left: vw(16);
      padding-right: vw(16);
      .item {
        flex: 1;
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: left;
        &:last-child {
          text-align: right;
        }
      }
    }
    .l_c_header {
      height: vh(40);
      line-height: vh(40);
    }
    .l_c_item {
      height: vh(43);
      line-height: vh(43);
      &:nth-of-type(odd) {
        height: vh(36);
        line-height: vh(36);
        background-color: rgba(13, 255, 169, 0.15);
      }
    }
  }
  // 实时作业
  .l_bottom_center {
    height: vh(246);
    padding-right: vw(40);
    .b_container,
    .seamless-warp {
      overflow: hidden;
      padding: vh(0) vh(6) vh(16) vh(6);
    }
    .l_b_item {
      height: vw(86);
      margin-bottom: vh(6);
      display: flex;
      &_left {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: vw(66);
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        border: 1px solid;
        border-right: none;
        border-image: linear-gradient(0deg, #074824, #07612f) 10 10;
        background: linear-gradient(
          0deg,
          rgba(14, 201, 136, 0.65) 0%,
          rgba(13, 255, 169, 0.65) 50%,
          rgba(14, 201, 136, 0.65) 100%
        );
      }
      &_right {
        line-height: vw(17.5);
        flex: 1;
        padding: vh(4) vw(10) 0 vw(10);
        font-size: fontSize(13);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        border: 1px solid;
        border-left: none;
        border-image: linear-gradient(0deg, #074824, #07612f) 10 10;
        background: linear-gradient(
          0deg,
          rgba(6, 84, 57, 0.25) 0%,
          rgba(13, 255, 169, 0.25) 50%,
          rgba(14, 201, 136, 0.25) 100%
        );
        &_top,
        &_center {
          margin-bottom: vh(3.5);
        }
      }
    }
  }
  // 左下
  .l_bottom {
    flex: 1;
    height: vh(260);
    padding-right: vw(40);
    display: flex;
    flex-direction: column;
    .month_select {
      position: absolute;
      top: vh(5);
      right: vw(5);
    }
  }
}
// 右侧样式
::v-deep.right_panel {
  padding-left: vw(0);
  padding-right: vw(24);
  position: absolute;
  right: 0;
  height: 100%;
  .r_top {
    .r_t_item {
      left: auto;
      right: vw(14);
      &:last-child {
        left: auto;
      }
    }
  }
  .r_center {
    height: vh(430);
    padding-left: vw(10);
    padding-bottom: vh(20);
    .b_container {
      padding-left: vw(16);
      .chart_info {
        width: 100%;
        display: flex;
        flex: 1;
        .info_panel {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          padding-top: vh(42);
          flex: 1;
          .month_select {
            position: absolute;
            top: vh(10);
            right: vw(10);
          }
          .switch_panel {
            display: flex;
            width: vw(96);
            height: vh(28);
            background: #165e44;
            font-size: fontSize(14);
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #bae8c0;
            position: absolute;
            top: vh(5);
            left: vw(-110);
            .btn {
              flex: 1;
              text-align: #bae8c0;
              border: 1px solid #0dffaa;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              &:first-child {
                border-radius: 4px 0 0 4px;
                border-right: 0;
              }
              &:last-child {
                border-radius: 0 4px 4px 0;
                border-left: 0;
              }
              &.active {
                color: #fff;
                background: #12a470;
                border-color: #0dffaa;
              }
            }
          }
          .i_item {
            font-size: fontSize(14);
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            .i_bottom {
              font-size: fontSize(22);
            }
            &:nth-of-type(2) {
              .i_bottom {
                color: #0dffaa;
              }
            }
            &:nth-of-type(3) {
              .i_bottom {
                color: #ffae0d;
              }
            }
            &:nth-of-type(4) {
              .i_center {
                span {
                  color: #0dffaa;
                  &.other {
                    color: #ffae0d;
                  }
                }
              }
              .i_bottom {
                color: #ffffff;
                .icon {
                  display: inline-block;
                  width: vw(13);
                  height: vh(15);
                  background: url("../../assets/images/work/icon_arrow_top.png")
                    no-repeat;
                  background-size: 100% 100%;
                  &.rotate {
                    background: url("../../assets/images/work/icon_arrow_down.png")
                      no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .r_bottom {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: vw(40);
  }
}
.info-detail-item {
  display: flex;
  line-height: vh(24);
  align-items: flex-start;
  margin-bottom: vh(6);
  .label {
    width: vw(130);
    color: #e9f0f7;
    text-align: right;
    font-size: fontSize(12);
    white-space: nowrap;
  }
  .value {
    color: #0dffa9;
    flex: 1;
    font-size: fontSize(12);
  }
}
::v-deep.township-dialog {
  .modal-container {
    position: fixed;
    // width: vw(230) !important;
    padding: 0;
    top: 0;
    left: 0;
    transform: none;
    border-radius: 0;
    .modal-content {
      padding: 0 0px;
    }
  }
}

// ::v-deep.drc_select {
//   width: vw(224);
//   height: vh(43);
//   background: url("../../assets/images/common/bg_zd_l.png") no-repeat;
//   background-size: 100% 100%;
//   position: absolute;
//   z-index: 9;
//   top: vh(28);
//   right: vw(503);
//   display: flex;
//   align-items: center;
//   padding: vh(16) 0 0 0;
//   .work_select {
//     padding: 0 vw(18) 0 vw(6);
//     width: 100%;
//     .el-input__inner {
//       padding: 0 vw(10) 0 vw(0);
//     }
//   }
// }
::v-deep.select_panel {
  position: absolute;
  top: vh(62);
  left: 48.5vw;
  z-index: 999;
  margin: 0 auto;
  display: flex;
  translate: -50% 0%;
  .select_left,
  .select_right {
    display: flex;
    border-radius: vw(4);
    background-color: #0a441f;
    border: 1px solid #7dab83;
    .label {
      width: vw(72);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      background-color: #2f7b5f;
      border-top-left-radius: vw(4);
      border-bottom-left-radius: vw(4);
    }
    .year_panel,
    .viewarea_panel {
      padding: 0;
      .el-input__inner {
        padding: 0 vw(20) 0 vw(10);
        height: vh(28);
        line-height: vh(28);
        text-align: left;
      }
      .el-input__suffix {
        right: vw(10);
      }
    }
  }
  .select_left {
    .year_panel {
      width: vw(84);
      .el-input__inner {
        padding: 0 vw(20) 0 vw(18);
      }
    }
  }
  .select_right {
    margin-left: vw(24);
    .viewarea_panel {
      width: vw(226);
    }
  }
}
.left_panel {
  left: 0;
  transition: all 300ms;
  &.left_fold_close {
    left: -100%;
    transition: all 300ms;
  }
}
.right_panel {
  right: 0;
  transition: all 300ms;
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}

::v-deep.drc_select {
  width: vw(144);
  height: vh(41);
  background: url("../../assets/images/common/bg_zd.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 9;
  top: vh(29);
  right: vw(529);
  display: flex;
  align-items: center;
  padding: vh(4) 0 0 0;
  transition: all 300ms;
  &:before {
    content: "";
    position: absolute;
    width: vw(16);
    height: vh(17);
    background: url("../../assets/images/common/icon_zd.png") no-repeat;
    background-size: 100% 100%;
    left: vw(19);
  }
  .work_select {
    padding: 0 vw(10) 0 0;
    .el-input__inner {
      padding: 0 vw(10) 0 vw(38);
      text-align: center;
    }
  }
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}
.filter-panel-switch {
  position: absolute;
  z-index: 9;
  top: vh(78);
  right: vw(470);
  width: vw(50);
  height: 48px;
  background-image: url(./components/icons/icon_search.png);
  background-size: 100%;
  cursor: pointer;
  &.blue {
    background-image: url(./components/icons/icon_search_blue.png);
  }
  &.active {
    background-image: url(./components/icons/icon_search_c.png);
  }
}
.filter-panel-bg {
  position: absolute;
  top: vh(80);
  right: vw(526);
  z-index: 10;
  width: vw(168);
  height: vh(95);
  background: #0a461fbf;
  border-radius: vw(8);
  border: 1px solid #7dab83b9;
  backdrop-filter: blur(1px);
  &.blue {
    background-color: #0a3554b5;
    border-color: #0a3554fa;
  }
  &.canVisibleSeasonProgress {
    height: vh(135);
  }
}
::v-deep.filter-panel-top {
  position: absolute;
  top: vh(90);
  right: vw(536);
  z-index: 10;
  width: vw(148);
  background: #0c4c24b3;
  box-shadow: 0px 0px 4px 0px #ffffff;
  border-radius: 4px;
  padding: vh(6) vw(8);
  display: flex;
  align-items: center;
  &.blue {
    background-color: #0a3554b5;
  }
  .el-switch {
    margin-right: 8px;
  }
  .text {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: fontSize(14);
    color: #fff;
    line-height: 10px;
  }
}

::v-deep.filter-panel-bottom {
  position: absolute;
  top: vh(132);
  right: vw(536);
  width: vw(148);
  z-index: 10;
  box-shadow: 0px 0px 4px 0px #ffffff;
  background: #0c4c24b3;
  border-radius: 4px;
  padding: vh(6) vw(8);
  display: flex;
  align-items: center;
  &.blue {
    background-color: #0a3554b5;
  }
  &.level-2 {
    top: vh(174);
  }
  .el-switch {
    margin-right: 8px;
  }
  .text {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: fontSize(14);
    color: #fff;
    line-height: 10px;
  }
}
</style>
